import {createLazyComponent} from 'helpers/createLazyComponent'
import React from 'react'

const FamilyBooksLazy = createLazyComponent(() => import('./containers/FamilyBooks'))

const FamilyBooks = (props) => <FamilyBooksLazy {...props} />

export default FamilyBooks
